module.exports = __webpack_public_path__ + "static/media/full-modal-header.337b4f58.png";